module.exports = __webpack_public_path__ + "img/50.a21f8ae8.png";